import { ArticleQuizConfig } from './types'

/**
 * Mapa principal: docId (string) -> configuração do quiz daquele artigo.
 * Use docId como chave estável; slugs podem mudar com edições editoriais.
 *
 * Para adicionar um artigo:
 *   '<docId>': {
 *     questions: [
 *       { question: '...', options: [{ label: 'Sim' }, { label: 'Não' }] },
 *       ...
 *     ],
 *     // finalStep e whatsappMessage são opcionais — sobrescrevem os defaults
 *   }
 */
export const ARTICLE_QUIZZES: Record<string, ArticleQuizConfig> = {
  '1641192459': {
    questions: [
      {
        question: 'Você quer saber se tem ordem de prisão em aberto?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Tem o nome completo e CPF da pessoa a pesquisar?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Encontrou algo na pesquisa e não sabe o que fazer?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1745891356': {
    questions: [
      {
        question: 'O governo foi condenado a te pagar algum valor?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você tem o número do seu processo em mãos?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Já tentou consultar esse pagamento pelo site do tribunal?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1670211573': {
    questions: [
      {
        question: 'Você pediu um benefício ao INSS e ele fica parado sem resposta?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Já fez a perícia médica ou avaliação social exigida?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Faz mais de 90 dias que você está esperando a resposta?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1170970882': {
    questions: [
      {
        question: 'Você quer pesquisar se alguém tem passagem pela polícia?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Tem o nome completo e CPF dessa pessoa?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'A pessoa mora no mesmo estado que você?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '3966889416': {
    questions: [
      {
        question: 'Você quer saber se tem ordem de prisão em aberto?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Tem o nome completo e CPF da pessoa a pesquisar?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Encontrou algo na pesquisa e não sabe o que fazer?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '2184803995': {
    questions: [
      {
        question: 'Você pediu um benefício ao INSS e quer saber o que está acontecendo?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Sabe se é um processo no INSS ou já foi para a Justiça?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Tem o número do pedido ou do processo em mãos?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1281843970': {
    questions: [
      {
        question: 'Já faz mais de 30 dias que está nessa fase de espera?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'O juiz já encerrou a fase de provas e ainda não houve sentença?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '2025321215': {
    questions: [
      {
        question: 'Você está acompanhando esse processo como réu ou como autor?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Já faz mais de 5 dias que o processo está concluso e nada aconteceu?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1725830163': {
    questions: [
      {
        question: 'Você quer cancelar uma medida protetiva que pediu?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'As duas partes já se reconciliaram?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1133597059': {
    questions: [
      {
        question: 'O crime cometido envolveu violência ou ameaça?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'A pessoa tem bom comportamento no presídio?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '373738164': {
    questions: [
      {
        question: 'O dinheiro bloqueado é do seu salário ou aposentadoria?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      { question: 'O valor estava numa poupança?', options: [{ label: 'Sim' }, { label: 'Não' }] },
      {
        question: 'Você foi avisado antes de a conta ser bloqueada?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1898306627': {
    questions: [
      {
        question: 'Você está tentando cobrar uma dívida de alguém?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Tem o CPF ou o nome completo dessa pessoa?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Já tentou achar o endereço de outra forma?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '2722536080': {
    questions: [
      {
        question: 'Sabe em qual cartório o imóvel está registrado?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você tem o número de matrícula do imóvel?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1843551961': {
    questions: [
      {
        question: 'Já faz mais de 30 dias que está nessa fase de espera?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'O juiz já encerrou a fase de provas e ainda não houve sentença?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '701839164': {
    questions: [
      {
        question: 'Você quer saber se tem ordem de prisão em aberto?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Tem o nome completo e CPF da pessoa a pesquisar?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Encontrou algo na pesquisa e não sabe o que fazer?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '5493701095': {
    questions: [
      {
        question: 'Você quer saber se tem ordem de prisão em aberto?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Tem o nome completo e CPF da pessoa a pesquisar?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Encontrou algo na pesquisa e não sabe o que fazer?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '3698797164': {
    questions: [
      {
        question: 'Seu extrato mostra algum número de processo ou código do bloqueio?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você tem alguma dívida ou processo que sabia que existia?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Já tentou perguntar para o banco o que aconteceu?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '3005216285': {
    questions: [
      {
        question: 'Você tem a certidão de nascimento, casamento ou óbito em mãos?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'A certidão é nova (com código de barras ou QR Code)?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1667530306': {
    questions: [
      {
        question: 'Já tentou pesquisar o seu nome no site do tribunal do seu estado?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Quer saber também se tem ordem de prisão contra você?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '2181544741': {
    questions: [
      { question: 'Tem o CPF dessa pessoa?', options: [{ label: 'Sim' }, { label: 'Não' }] },
      {
        question: 'É para cobrar uma dívida ou para outro motivo?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '691852331': {
    questions: [
      {
        question: 'Já passou das 21h do dia em que fez a perícia?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'O benefício que você pediu é auxílio-doença ou aposentadoria?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1765413247': {
    questions: [
      {
        question: 'Você já acessou o site do Detran?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Tem a placa e o RENAVAM do veículo?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1580377258': {
    questions: [
      {
        question: 'Tem o número do processo para acompanhar?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você é vítima e quer saber como acompanhar o seu caso?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você foi intimado e não sabe o que precisa fazer?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1859016513': {
    questions: [
      {
        question: 'Você é o autor ou o réu no processo em que essa movimentação apareceu?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Foi você ou a outra parte que enviou essa manifestação?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1979054721': {
    questions: [
      {
        question: 'Você sabe em qual cidade seu familiar foi preso?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'A prisão aconteceu há menos de 2 dias?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Já tentou ligar para a delegacia da cidade?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1435453373': {
    questions: [
      {
        question: 'Tem RG, comprovante de endereço e documento de parentesco?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'A cadeia já sabe que você quer ser visitante?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1841201606': {
    questions: [
      {
        question: 'A ação é contra o governo, INSS ou prefeitura?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'O juiz já deu a decisão final sem possibilidade de recurso?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'O valor que você vai receber é alto (acima de 60 salários mínimos)?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '929505430': {
    questions: [
      {
        question: 'Você pediu demissão por vontade própria?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Cumpriu os 30 dias de aviso antes de sair?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Tem férias ou 13º que ainda não recebeu?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '2029041729': {
    questions: [
      {
        question: 'O INSS foi condenado a te pagar algum valor?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Já passou mais de 60 dias desde que o pagamento foi expedido?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'O valor que você tem a receber é alto (acima de 60 salários mínimos)?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1435905652': {
    questions: [
      {
        question: 'Quem vai pagar tem salário fixo com carteira assinada?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Já existe pensão definida antes e você quer mudar o valor?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'A criança tem alguma necessidade especial de saúde?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1227186382': {
    questions: [
      {
        question: 'Já faz mais de 1 dia desde que você fez a perícia no INSS?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'O prazo do seu benefício já passou sem resposta?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Já tentou ligar para o 135 para perguntar o que aconteceu?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '668083565': {
    questions: [
      {
        question: 'Sua renda mensal é de até 3 salários mínimos?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você já procurou a Defensoria Pública na sua cidade?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '3499788760': {
    questions: [
      {
        question: 'Tem a placa e o RENAVAM do veículo?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Já fez a busca no site do Detran?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1836709707': {
    questions: [
      {
        question: 'Você tem acesso ao andamento atualizado do processo?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Sabe se o juiz já deu alguma decisão?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '2701101498': {
    questions: [
      {
        question: 'Tem cobranças ou dívidas no seu CPF que você não reconhece?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você já entrou no site do governo para checar?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '596165016': {
    questions: [
      {
        question: 'Você tem uma doença ou deficiência comprovada por médico?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Tem o laudo médico que comprova a sua condição?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você quer comprar um carro 0km?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '345027971': {
    questions: [
      {
        question: 'O trabalhador entregou mais de um atestado médico pelo mesmo problema?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'A soma de todos os dias de atestado passou de 15 dias?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'O patrão ainda não encaminhou para o INSS?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '5285834984': {
    questions: [
      {
        question: 'Você tem print de conversa de WhatsApp para usar como prova?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'O print é para um processo criminal?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'A prova foi obtida de um celular apreendido pela polícia?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '5404871404': {
    questions: [
      {
        question: 'Você é servidor público, aposentado ou pensionista?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Tem desconto do CredCesta ou Banco Master no seu contracheque?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Os descontos continuam mesmo sem você ter pedido?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1397658933': {
    questions: [
      {
        question: 'Você sabe o nome completo de quem faleceu?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Precisa da certidão de óbito para fazer inventário ou pedir pensão?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Sabe em qual cidade o óbito foi registrado?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '567441232': {
    questions: [
      {
        question: 'Tem as contas de energia dos últimos 5 anos?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você é pessoa física (residência) ou empresa?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '703485271': {
    questions: [
      {
        question: 'Você sofreu algum prejuízo ou humilhação causado por empresa?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Tem provas do que aconteceu (fotos, recibos, mensagens)?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'O valor do seu prejuízo é de até 20 salários mínimos?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1864664513': {
    questions: [
      {
        question: 'Você abriu o processo ou foi o réu?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Houve decisão final no processo?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '476642073': {
    questions: [
      {
        question: 'Faleceu um parente próximo como marido, esposa, filho ou pai?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você trabalha com carteira assinada?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'A empresa não quer liberar os dias de luto?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1865149401': {
    questions: [
      {
        question: 'Você teve algum problema com uma casa de apostas online?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Tem comprovantes do dinheiro que você colocou?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'A plataforma bloqueou sua conta e/ou não deixa sacar?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1347566135': {
    questions: [
      {
        question: 'Alguém da família faleceu e você quer saber se abriram inventário?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'O falecimento ocorreu há mais de 1 ano?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você é herdeiro e não foi avisado sobre o inventário?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1226788301': {
    questions: [
      {
        question: 'A tornozeleira é para você ou para alguém da sua família?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Já houve algum problema com o dispositivo, como falta de carga ou sinal?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você tem dúvidas sobre o que pode ou não pode fazer usando a tornozeleira?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '670325274': {
    questions: [
      {
        question: 'Você comprou pela internet ou por telefone?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      { question: 'O produto tem algum defeito?', options: [{ label: 'Sim' }, { label: 'Não' }] },
      {
        question: 'Faz menos de 7 dias que você recebeu o produto?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '664308124': {
    questions: [
      {
        question: 'O INSS aprovou seu benefício mas ainda não começou a pagar?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Já faz mais de 45 dias desde a aprovação sem receber?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Já ligou para o 135 para perguntar o que está acontecendo?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1310995385': {
    questions: [
      {
        question: 'O juiz já mandou a outra parte te pagar e ela não pagou?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Já passou o prazo de 15 dias para a outra parte cumprir?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'A dívida é com uma empresa ou pessoa física?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '2160677815': {
    questions: [
      {
        question: 'O casal tem filhos menores de 18 anos?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Os dois concordam com o divórcio?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Vocês têm bens como casa ou carro para dividir?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1835769269': {
    questions: [
      {
        question: 'Alguém da família faleceu e deixou dinheiro na conta?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você tem certidão de óbito e documento de parentesco?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Existem outros herdeiros que podem reclamar esse dinheiro?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '249964506': {
    questions: [
      {
        question: 'Você tem mais de 25 anos e ficha limpa?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Já fez os testes de aptidão psicológica e de tiro?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você quer guardar a arma em casa ou carregar na rua?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1191296485': {
    questions: [
      {
        question: 'Você foi vítima de um acidente e está pensando em entrar na Justiça?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'O acidente causou danos só no veículo ou você também se machucou?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '2770724739': {
    questions: [
      {
        question: 'Você tem o CNPJ ou o nome da empresa?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Quer esse documento para fechar um negócio?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'A empresa é uma LTDA ou outro tipo?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '2660473657': {
    questions: [
      {
        question: 'O dinheiro bloqueado é do seu salário ou aposentadoria?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      { question: 'O valor estava numa poupança?', options: [{ label: 'Sim' }, { label: 'Não' }] },
      {
        question: 'Você já foi avisado sobre o processo que bloqueou a conta?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1438740700': {
    questions: [
      {
        question: 'A dívida que sujou seu nome tem mais de 5 anos?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      { question: 'Você reconhece essa dívida?', options: [{ label: 'Sim' }, { label: 'Não' }] },
      {
        question: 'Você quer negociar ou acha que a cobrança é errada?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '684463962': {
    questions: [
      {
        question: 'Você mora no imóvel há mais de 10 anos sem que outros herdeiros reclamem?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você paga as contas e cuida do imóvel como se fosse seu?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '3289097264': {
    questions: [
      {
        question: 'Você trabalha por conta própria ou é dona de casa?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Já tem algum tempo de contribuição ao INSS?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'A data do parto está a mais de 10 meses de distância?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1746458757': {
    questions: [
      {
        question: 'Você tem provas de que trabalhava lá? (mensagens, fotos, recibos)',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Faz menos de 2 anos que o trabalho terminou?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você foi mandado embora ou pediu para sair?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '2195573458': {
    questions: [
      {
        question: 'O juiz mandou o INSS pagar e ele ainda não começou?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Já faz mais de 45 dias desde a decisão do juiz?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '184254263': {
    questions: [
      {
        question: 'Você é o autor e acabou de receber a contestação do réu?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'O réu trouxe argumentos ou documentos novos para o caso?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '5399639035': {
    questions: [
      {
        question: 'Você já contribui para o INSS há mais de 15 anos?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você pretende se aposentar em 2026?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você sabe quantos anos faltam para atingir a aposentadoria?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '2483868352': {
    questions: [
      {
        question: 'Você pediu o BPC/LOAS e já fez a perícia e a avaliação social?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Já faz mais de 90 dias desde essas avaliações sem resposta?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'O pedido é para um idoso ou para uma pessoa com deficiência?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '911549498': {
    questions: [
      {
        question: 'O casal tem filhos menores de 18 anos?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Os dois concordam com o divórcio?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Vocês têm bens como casa ou carro para dividir?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1172146698': {
    questions: [
      {
        question: 'Tem o CPF ou CNPJ para fazer a pesquisa?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'É para emitir certidão ou só para consultar?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '2518347514': {
    questions: [
      {
        question: 'Você desistiu do consórcio por vontade própria?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'O grupo de consórcio ainda está em andamento?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Já tentou negociar a devolução com a empresa do consórcio?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '2683663074': {
    questions: [
      {
        question: 'Você é dono da empresa com dúvida sobre o enquadramento sindical?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Já recebeu alguma cobrança ou notificação do sindicato que não reconhece?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você tem funcionários e está em dúvida sobre qual convenção coletiva aplicar?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1758268608': {
    questions: [
      {
        question: 'Você percebeu um erro na petição inicial depois de entrar com o processo?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'O réu já foi citado ou o processo ainda está na fase inicial?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Foi o juiz quem pediu a emenda ou a iniciativa é sua?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1472149883': {
    questions: [
      {
        question: 'Você foi demitido sem justa causa com carteira assinada?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Está desempregado há mais de 3 meses?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      { question: 'Sua renda familiar é baixa?', options: [{ label: 'Sim' }, { label: 'Não' }] },
    ],
  },
  '3980082296': {
    questions: [
      {
        question: 'O dinheiro bloqueado é do seu salário ou aposentadoria?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você foi avisado antes do bloqueio acontecer?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '3271432547': {
    questions: [
      {
        question: 'O valor da sua ação trabalhista é de até 40 salários mínimos?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Já tentaram fazer um acordo e não deu certo?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'O processo ainda está na primeira audiência?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '2548709635': {
    questions: [
      {
        question: 'A plataforma bloqueou sua conta ou não deixa sacar?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você tem comprovantes dos depósitos que fez?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '2259798185': {
    questions: [
      {
        question: 'Você quer entrar na Justiça e não sabe quanto colocar no valor da causa?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question:
          'O seu pedido envolve só dinheiro ou também tem outros tipos de prejuízo, como dano moral?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '196964430': {
    questions: [
      {
        question:
          'Você sabe quais benefícios a convenção coletiva da sua categoria garante além do salário?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Seu empregador está cumprindo tudo o que está previsto na CCT da sua categoria?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question:
          'Você já teve algum direito negado e não sabe se ele está garantido na convenção coletiva?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '2168791383': {
    questions: [
      {
        question: 'O advogado já te cobrou um valor e você acha que está caro?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'O pagamento foi combinado como percentual do que você ganhar?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '2904580585': {
    questions: [
      {
        question: 'O médico prescreveu o Mounjaro para você?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'O plano de saúde ou o SUS já negou fornecer o remédio?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você tem o diagnóstico de diabetes ou obesidade documentado?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1597959101': {
    questions: [
      {
        question: 'Você trabalha ou trabalhou como vigilante?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Tem documento do empregador que comprove sua função?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'O INSS negou o seu pedido de aposentadoria?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '128101929': {
    questions: [
      {
        question: 'Você precisa de advogado mas não pode pagar?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Sua renda mensal é de até 3 salários mínimos?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você já procurou a Defensoria Pública na sua cidade?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '2492394662': {
    questions: [
      {
        question: 'Você já fez a perícia do INSS e está esperando o resultado?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Já passou mais de 1 dia desde que você fez a perícia?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'O benefício que você pediu é auxílio-doença ou aposentadoria?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '583581967': {
    questions: [
      {
        question: 'Você quer verificar se o seu advogado é registrado na OAB?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Tem o nome ou o número de registro do advogado?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
  '1237971938': {
    questions: [
      {
        question: 'A outra parte já ficou sabendo da ação?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'A outra parte já mandou a defesa dela para o juiz?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
      {
        question: 'Você quer desistir porque chegaram a um acordo?',
        options: [{ label: 'Sim' }, { label: 'Não' }],
      },
    ],
  },
}

/**
 * Mapa secundário: slug -> docId. Fallback quando o docId não vem disponível
 * ou para facilitar manutenção visual.
 */
export const SLUG_TO_DOC_ID: Record<string, string> = {
  'mandado-de-prisao': '1641192459',
  'como-consultar-rpvs-de-maneira-simples': '1745891356',
  'meu-beneficio-so-fica-em-analise-afinal-qual-e-o-prazo-que-o-inss-tem-para-analisar-o-meu-pedido':
    '1670211573',
  'voce-sabe-consultar-os-antecedentes-criminais-do-seu-companheiro': '1170970882',
  'como-consultar-mandado-de-prisao-pela-internet': '3966889416',
  'processo-inss-como-consultar': '2184803995',
  'o-juiz-tem-prazo-para-dar-a-sentenca-qual-e-demora': '1281843970',
  'conclusos-para-despacho-o-que-significa-no-processo': '2025321215',
  'como-cancelar-medida-protetiva': '1725830163',
  'progressao-de-regime-como-funciona-e-como-calcular': '1133597059',
  'bloqueio-judicial-ilegal-saiba-como-desbloquear-sua-conta-bancaria-e-recuperar-seu-dinheiro':
    '373738164',
  'como-descobrir-o-endereco-do-devedor-dicas-praticas-e-legais': '1898306627',
  'como-visualizar-a-matricula-do-seu-imovel-sem-precisar-ir-ao-cartorio-passo-a-passo':
    '2722536080',
  'quanto-tempo-demora-um-processo-que-esta-concluso-para-sentenca': '1843551961',
  'como-saber-se-tem-mandado-de-prisao-no-meu-nome': '701839164',
  'como-consultar-mandado-de-prisao-em-aberto-pelo-nome-ou-cpf': '5493701095',
  'como-faco-para-descobrir-qual-processo-resultou-no-bloqueio-da-minha-conta': '3698797164',
  'aprenda-a-localizar-o-livro-folha-e-termo-na-certidao': '3005216285',
  'como-saber-se-existe-algum-processo-criminal-em-curso-contra-mim': '1667530306',
  'consulta-bens-pelo-cpf-confira-a-forma-mais-pratica-de-realizar-essa-consulta-online':
    '2181544741',
  'saiba-qual-foi-o-resultado-da-sua-pericia-do-inss': '691852331',
  'como-saber-se-o-veiculo-esta-em-busca-e-apreensao': '1765413247',
  'consultar-intimacoes-para-casos-de-violencia-domestica-medida-protetiva': '1580377258',
  'juntada-de-peticao-de-manifestacao-o-que-e': '1859016513',
  'desvendando-o-misterio-como-localizar-o-paradeiro-de-um-parente-preso': '1979054721',
  'carteirinha-de-visitante-como-fazer': '1435453373',
  'quando-vou-receber-o-dinheiro-do-processo': '1841201606',
  'pedi-demissao-e-agora-o-que-tenho-direito-a-receber': '929505430',
  'prazos-para-pagamento-de-rpv-e-precatorio-pelo-inss-o-que-voce-precisa-saber': '2029041729',
  'como-calcular-pensao-alimenticia-na-pratica': '1435905652',
  'nao-saiu-o-resultado-da-pericia-do-inss-o-que-fazer': '1227186382',
  'advogado-gratuito': '668083565',
  'como-consultar-busca-e-apreensao-de-veiculos-guia-completo': '3499788760',
  'como-saber-se-ganhei-o-processo-causa': '1836709707',
  'como-saber-se-tem-empresa-no-meu-nome-passo-a-passo': '2701101498',
  'as-doencas-que-garantem-desconto-de-ate-30-na-compra-do-carro-zero': '596165016',
  'a-regra-geral-para-atestados-intercalados-ou-sucessivos': '345027971',
  'stj-enterra-a-era-do-print-de-whatsapp-como-prova-penal': '5285834984',
  'justica-determina-suspensao-de-descontos-do-credcesta-pkl-e-banco-master': '5404871404',
  'cadastro-nacional-de-falecidos': '1397658933',
  'como-pedir-restituicao-de-icms-na-conta-de-luz': '567441232',
  'dano-moral-quais-as-20-causas-que-mais-geram-indenizacoes-por-danos-morais': '703485271',
  'processo-arquivado-e-baixado-quer-dizer-causa-ganha': '1864664513',
  'o-luto-da-direito-a-dois-dias-de-dispensa-do-trabalho': '476642073',
  'caso-elize-matsunaga': '1234637720',
  'proferido-despacho-de-mero-expediente-o-que-e': '1834239050',
  'processo-legal-contra-casas-de-apostas': '1865149401',
  'onde-saber-se-ja-deram-entrada-no-inventario': '1347566135',
  'tornozeleira-eletronica-conheca-as-regras-envolvendo-o-uso-do-dispositivo': '1226788301',
  'enderecamento-de-pecas-conforme-o-cpc-2015': '521988028',
  'os-direitos-do-consumidor-na-troca-ou-devolucao-de-produtos': '670325274',
  'qual-o-prazo-para-o-inss-implantar-o-beneficio-concedido': '664308124',
  'o-que-e-cumprimento-de-sentenca-saiba-mais-sobre-essa-etapa-do-processo-civil': '1310995385',
  'como-descobrir-quem-e-o-dono-de-um-imovel-pelo-endereco': '4195197869',
  'como-fazer-o-divorcio-pela-internet': '2160677815',
  'como-saber-se-uma-pessoa-e-casada': '2581643996',
  'alvara-judicial-para-liberar-dinheiro-de-falecido-uma-alternativa-ao-inventario': '1835769269',
  'passo-a-passo-para-o-cidadao-comum-que-deseja-adquirir-uma-arma-de-fogo-para-defesa-pessoal':
    '249964506',
  'modelo-acao-de-indenizacao-por-danos-materiais-e-morais-acidente-de-transito': '1191296485',
  'como-encontrar-o-contrato-social-de-uma-empresa': '2770724739',
  'como-desbloquear-conta-bancaria-bloqueada-por-ordem-judicial': '2660473657',
  'acordao-publicado-qual-o-significado-o-que-vem-depois': '1833045963',
  'como-limpar-seu-nome-sozinho-e-sem-gastar-nada-passo-a-passo-definitivo': '1438740700',
  'lei-do-silencio-para-se-garantir-conheca-seus-direitos-e-deveres': '266427263',
  'e-possivel-usucapiao-de-bem-de-heranca-por-um-herdeiro': '684463962',
  'como-funciona-a-contribuicao-unica-antes-do-parto-para-ter-direito-ao-salario-maternidade':
    '3289097264',
  'como-funciona-o-acerto-de-quem-nao-tem-carteira-assinada': '1746458757',
  'descubra-agora-quanto-tempo-o-inss-tem-para-implantar-um-beneficio-judicial': '2195573458',
  'replica-no-codigo-de-processo-civil': '184254263',
  'aumento-da-idade-para-se-aposentar-em-2026-veja-o-que-mudou': '5399639035',
  'quanto-tempo-o-bpc-loas-fica-em-analise-entenda-o-processo-e-prazos-exigidos': '2483868352',
  'como-fazer-divorcio-on-line-como-fazer-o-divorcio-gratuito-como-dar-entrada-no-divorcio':
    '911549498',
  'como-saber-se-alguem-ou-uma-empresa-possui-processo-trabalhista': '1172146698',
  'lista-negra-dos-bancos-o-que-e-e-como-consultar': '1247918311',
  'como-excluir-o-nome-do-pai-da-certidao-de-nascimento': '2361564583',
  'regras-de-publicacao-da-comunidade-jusbrasil': '111561143',
  'desisti-do-meu-consorcio-posso-receber-meu-dinheiro-de-volta-imediatamente': '2518347514',
  'qual-sindicato-da-minha-empresa': '2683663074',
  'emenda-a-inicial-e-aditamento-a-inicial': '1758268608',
  'desempregado-tem-direito-a-4-beneficios-saiba-quais-voce-pode-receber': '1472149883',
  'conta-bancaria-com-saldo-bloqueado-saiba-como-desbloquear-e-recuperar-seu-dinheiro-com-urgencia':
    '3980082296',
  'quanto-tempo-demora-um-processo-trabalhista': '3271432547',
  'o-vicio-em-apostas-e-a-possibilidade-de-recuperacao-do-dinheiro-perdido': '2548709635',
  'calcule-o-valor-da-causa-sem-medo': '2259798185',
  'acordo-e-convencao-coletiva-de-trabalho': '196964430',
  'ato-ordinatorio-praticado-o-que-significa-isso': '253713931',
  'sites-gratuitos-para-buscar-bens-de-devedores-ferramentas-online-essenciais-para-localizacao-de-patrimonio':
    '2660745845',
  'como-funciona-a-contagem-de-prazo-apos-a-disponibilizacao-no-diario-da-justica': '328066366',
  'honorarios-advocaticios-ate-quanto-um-advogado-pode-cobrar': '2168791383',
  'como-consultar-relacao-do-imovel-por-cpf': '1509214830',
  'como-conseguir-o-mounjaro-pelo-plano-de-saude-ou-pelo-sus': '2904580585',
  'acao-revisional-entenda-como-diminuir-a-parcela-do-financiamento-do-seu-veiculo': '402486730',
  'foi-aprovado-aposentadoria-especial-para-vigilantes-andamento-do-tema-no-stf-e-stj':
    '1597959101',
  'justica-gratuita-ou-assistencia-juridica-gratuita-defensoria-publica': '128101929',
  'quanto-tempo-demora-para-sair-o-resultado-da-pericia-do-inss-entenda-o-processo-e-prazos':
    '2492394662',
  'como-obter-informacoes-sobre-seu-advogado-atraves-do-cna-oab-cadastro-nacional-dos-advogados-cna':
    '583581967',
  'dr-eu-entrei-com-uma-acao-judicial-mas-eu-me-arrependi-e-quero-desistir-do-processo-e-possivel':
    '1237971938',
}
